/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hidden{display:none!important}.area-measure-auto-create{margin-top:.5rem;margin-bottom:.75rem}.action-button{font-size:16px;background-color:transparent;border:1px solid #d3d3d3;color:#6e6e6e;height:32px;width:32px;text-align:center;box-shadow:0 0 1px rgba(0,0,0,.3)}.action-button:focus,.action-button:hover,.active{background:#0079c1;color:#e4e4e4}.esri-area-measurement-3d__hint-text{margin:0}"];
export { styles as styles };
